import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProfileCard = ({
  job,
  user,
  onAssingedJob,
  onUnAssingedJob,
  onAttendancePress,
}) => {
  const navigate = useNavigate();
  const navigateToJobSeekerDetail = (id) => {
    navigate(`/job-seeker-details/${id}`, { state: user });
  };

  console.log(job, "jobjobjobjobjob");

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, p: 2, width: 300 }}>
      <Box display="flex" justifyContent="center" mt={2}>
        <Avatar
          src={user.image}
          alt={user.name}
          sx={{ width: 80, height: 80, border: "3px solid #3f51b5" }}
        />
      </Box>

      <CardContent>
        <Typography variant="h6" align="center" fontWeight="bold">
          {user.jobSeekerId?.firstname} {user.jobSeekerId?.lastname}
        </Typography>

        <Typography variant="body2" color="textSecondary" align="center">
          {user?.jobSeekerId?.email}
        </Typography>

        <Typography variant="body1" color="textPrimary" align="center" mt={1}>
          {user.bio}
        </Typography>

        <Box display={"flex"} gap={2} mt={2}>
          <Button
            variant="contained"
            size="small"
            sx={{ fontSize: "10px" }}
            onClick={() => navigateToJobSeekerDetail(user._id)}
          >
            View Details
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ fontSize: "10px" }}
            onClick={!user?.isAssigned ? onAssingedJob : onUnAssingedJob}
            disabled={
              job?.jobStatus == "Cancelled" || job?.jobStatus == "Completed"
            }
          >
            {!user?.isAssigned ? "Assign Job" : "UnAssign Job"}
          </Button>
        </Box>
        <Button
          variant="contained"
          size="small"
          sx={{ fontSize: "10px", mt: 2 }}
          onClick={onAttendancePress}
        >
          View Attendance
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProfileCard;
